import { SVGProps } from 'react';

function DoubleCheck(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={12}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m8.807 10.473-3.4-3.4a1.518 1.518 0 0 1 2.148-2.146l2.163 2.162 4.05-5.4a1.518 1.518 0 0 1 2.43 1.822l-5.102 6.8a1.517 1.517 0 0 1-2.289.162Z"
        stroke="#28BD9A"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <path
        d="m8.805 3.691 1.502-2.004a1.52 1.52 0 0 1 1.632-.548M6.928 10.83a1.518 1.518 0 0 1-1.582-.357l-3.4-3.4a1.518 1.518 0 0 1 1.576-2.507"
        stroke="#28BD9A"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

DoubleCheck.defaultProps = {
  role: 'graphics-document',
};

export default DoubleCheck;
